import { CoreService } from "./../../base/core";
import { Injectable } from "@angular/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class StudentSessionsCheckoutService {

  constructor(private core: CoreService) { }
  
  getEducationPackageId(data: any): Observable<any> {
    return this.core.get(
      ServiceRoute.studentSessionsCheckout.cource.getCoursePackageId + data.CourseId +"&xAllSessionId="+ data.AllSessionId,
      new CommonHttpOption().headers
    );
  }

  getMarkTypeList(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.studentSessionsCheckout.markType.listCombo,
      data,
      new CommonHttpOption().headers
    );
  }

  getMarkClassificationList(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.studentSessionsCheckout.markClassification.listCombo,
      data,
      new CommonHttpOption().headers
    );
  }

  getMarkStudentList(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.studentSessionsCheckout.markStudent.getMarkStudentList,
      data,
      new CommonHttpOption().headers
    );
  }

  getStudentAttendance(data: any): Observable<any> {
    return this.core.post(
      ServiceRoute.studentSessionsCheckout.cource.getStudentAttendance,
      data,
      new CommonHttpOption().headers
    );
  }

  saveStudentAttendance (data): Observable<any> {
    return this.core.post(
      ServiceRoute.studentSessionsCheckout.cource.saveStudentAttendance,
      data,
      new CommonHttpOption().headers
    );
  }

  setToFinal (data : any): Observable<any> {
    return this.core.post(
      ServiceRoute.studentSessionsCheckout.markStudent.setToFinal,
      data,
      new CommonHttpOption().headers
    );
  }
  saveMarkStudent (data): Observable<any> {
    return this.core.post(
      ServiceRoute.studentSessionsCheckout.markStudent.save,
      data,
      new CommonHttpOption().headers
    );
  }
}
